import React, {useState, useEffect} from 'react';
import {CSSTransition, SwitchTransition} from "react-transition-group";
import {FazendaObject} from "models/Fazenda";
import {useGetProprietario} from "lib/DataHooks/proprietarios";
import ModalBody, {ModalBodyPart} from "components/Modal";
import {PendingProprietario} from "../../Proprietarios/FormProprietario/controller";
import CadastroFazenda from "./CadastroFazenda";
import FormProprietarioEmbed, {FormProprietarioPageState} from "../../Proprietarios/FormProprietario/FormProprietarioEmbed";

interface FormFazendaProps {
  instance?: FazendaObject;
  onSubmit: () => void;
}

export type FormFazendaPageState = 'proprietario' | 'fazenda' | 'loading';

const FormFazenda: React.FC<FormFazendaProps> = (props) => {
  const {instance} = props;
  const [pageState, setPageState] = useState<FormFazendaPageState>('loading');
  const [proprietario, setProprietario] = useState<PendingProprietario>();
  const [iPropId, setIPropId] = useState<string>();
  const [stateFormProprietario, setStateFormProprietario] = useState<FormProprietarioPageState>('busca');
  const [fazendaPendingValues, setFazendaPendingValues] = useState<FazendaObject>();

  // hooks
  const [iProprietario, iPropIsLoadind] = useGetProprietario(iPropId);

  // reset
  useEffect(() => {
    // console.log('RESET FormFazenda');
    if (instance) {
      const {_proprietario} = instance;
      if (!_proprietario || !_proprietario.id)
        throw new Error(`Fazenda sem proprietario: ${instance}`);

      if (_proprietario.id !== iPropId) {
        setIPropId(_proprietario.id);
        setPageState('fazenda');
      }
    } else {
      setProprietario(undefined);
      setIPropId(undefined);
      setPageState('proprietario');
    }
  }, [instance, iPropId]);

  // set proprietario from instance
  useEffect(() => {
    if (iProprietario && !proprietario && !iPropIsLoadind) {
      // console.log('SET PendingProprietario from instance');
      setProprietario({
        mode: 'use',
        instance: iProprietario,
      });
    }
  }, [iPropIsLoadind, iProprietario, proprietario]);

  const onCompleteProprietario = (proprietario: PendingProprietario) => {
    setProprietario(proprietario);
    setPageState('fazenda');
  }

  const onClickProprietario = (values: FazendaObject) => {
    setFazendaPendingValues(values);
    setStateFormProprietario('confirmar');
    setPageState('proprietario');
  }

  return (
    <ModalBody>
      <SwitchTransition>
        <CSSTransition
          key={pageState}
          classNames="transition-slide-l"
          timeout={250}
        >
          <ModalBodyPart>
            {pageState === 'loading' &&
              <div>Waiting data...</div>
            }
            {pageState === 'proprietario' &&
              <FormProprietarioEmbed
                onComplete={onCompleteProprietario}
                proprietario={proprietario}
                doNotInsert={true}
                state={stateFormProprietario}
                fazenda={instance}
              />
            }
            {pageState === 'fazenda' && proprietario &&
              <CadastroFazenda
                instance={instance}
                proprietario={proprietario}
                onSubmit={props.onSubmit}
                onClickProprietario={onClickProprietario}
                pendingValues={fazendaPendingValues}
              />
            }
          </ModalBodyPart>
        </CSSTransition>
      </SwitchTransition>
    </ModalBody>
  );
}

export default FormFazenda;
